<div class="pdf-drawer" [class.open]="open">
  <div class="pdf-drawer__backdrop" (click)="onBackdropClick()"></div>
  @if (context) {
    <aside class="pdf-drawer__panel">
      <div class="pdf-drawer__head">
        <div class="pdf-drawer__title">
          Source · {{ context.sourceShort }}, p. {{ context.page }}
        </div>
        <button
          class="pdf-drawer__close"
          type="button"
          aria-label="Close"
          (click)="onCloseClick()"
        >
          <svg viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12" /></svg>
        </button>
      </div>
      <div class="pdf-drawer__body">
        <div class="pdf-preview" [ngClass]="'source-' + context.source">
          <div class="pdf-preview-head">
            <div class="pdf-preview-brand">
              <span class="pp-src">{{ context.sourceShort }}</span>
              <span class="pp-type">{{ sourceLabelUpper }}</span>
            </div>
            <div class="pdf-preview-pg">
              Page {{ context.page }} / {{ context.pageCount }}
            </div>
          </div>
          <div class="pdf-preview-rule"></div>
          <div class="pdf-preview-doc-title">{{ context.title }}</div>
          <div class="pdf-preview-byline">
            {{ context.author }} · {{ formatDate(context.date) }}
          </div>
          <div class="pdf-preview-section">
            <div class="pdf-preview-section-h">
              §{{ sectionIndex }} — {{ sectionLabel }}
            </div>
            <p class="pdf-preview-para">
              Market participants continue to underestimate the structural
              shifts driving our outlook for the remainder of 2026. As we've
              noted throughout this volume, the confluence of policy divergence
              and corporate cashflow dynamics creates an environment where
              conviction positioning is rewarded.
            </p>
            <p class="pdf-preview-para">
              In the pages that follow, we outline the core trades, sized by
              conviction and mapped against the macro regime framework
              introduced in Part I.
            </p>
            <p class="pdf-preview-para pdf-preview-anchor">
              <mark class="pdf-excerpt-hl">"{{ context.excerpt }}"</mark>
            </p>
            <p class="pdf-preview-para">
              The implications for portfolio construction follow naturally: size
              exposure to match conviction, respect the risk budget set out in
              the mandate, and re-examine the position at the next cycle
              waypoint.
            </p>
            <p class="pdf-preview-para">
              We will revisit this view in our mid-quarter update, with
              sensitivity to incoming macro prints and second-order rotations
              within the relevant factor basket.
            </p>
          </div>
          <div class="pdf-preview-foot">
            <span>{{ sourceShortUpper }} · CONFIDENTIAL</span>
            <span>{{ context.page }} / {{ context.pageCount }}</span>
          </div>
        </div>
      </div>
      <div class="pdf-drawer__foot">
        <button class="btn btn-ghost" type="button" (click)="onCloseClick()">
          Close
        </button>
        <button
          class="btn btn-primary"
          type="button"
          (click)="onDownloadClick()"
        >
          Download original PDF
        </button>
      </div>
    </aside>
  }
</div>
